var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-box"},[_c('div',{staticClass:"edit-label",attrs:{"contenteditable":"true"},on:{"blur":_vm.blur,"click":_vm.clickHandler}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/TableHeaderBox/TableHeaderBox.vue